
import instance from "../config";
import { limpiarSesion } from "../helpers/tokenSesion";
import { CACHE_API_DATOS } from "../pwa/constantesPwa";


const Login = async (username, password) => {
    const { data } = await instance.post('/auth/login', { username, password, }) // localhost:4000/v1/auth/login 
    return data;
};


const updatePassword = async (id, data) => {
    try {
        const response = await instance.put(`/auth/login/${id}`, data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }

}

// Metodo para actualizar el pin
const updatePin = async (id, data) => {
    try {
        const response = await instance.patch(`/auth/login/pin/${id}`, data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }

}


const Logout = () => {
    limpiarSesion();
    // Los datos guardados para usar sin conexión son del usuario que sale
    if ('caches' in window) caches.delete(CACHE_API_DATOS);
}

export {
    Login,
    Logout,
    updatePassword,
    updatePin,
}